module.exports = __webpack_public_path__ + "img/ergoframe.4d45e6d3.jpg";